import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en';
import deLocale from 'element-ui/lib/locale/lang/de';
import esLocale from 'element-ui/lib/locale/lang/es';
import frLocale from 'element-ui/lib/locale/lang/fr';
import koLocale from 'element-ui/lib/locale/lang/ko';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import ptLocale from 'element-ui/lib/locale/lang/pt-br';

import Element from 'element-ui';
import { getLanguage } from '@/utils/auth';
import zhCN from '@/lang/zh-CN.json';
import en from '@/lang/en.json';
import es from '@/lang/es.json';
import de from '@/lang/de.json';
import ko from '@/lang/ko.json';
import fr from '@/lang/fr.json';
import ru from '@/lang/ru.json';
import pt from '@/lang/pt.json';
Vue.use(VueI18n);
import { defaultLang } from '@/enum';

const i18n = new VueI18n({
    locale: getLanguage() || defaultLang, // set locale
    fallbackLocale: defaultLang, // 默认语言设置，当其他语言没有的情况下，使用cn作为默认语言
    messages: {
        'zh-CN': Object.assign(zhCN, zhLocale),
        'zh-HK': Object.assign(zhCN, zhLocale),
        de: Object.assign(de, deLocale), // 德语
        en: Object.assign(en, enLocale), // 英语
        es: Object.assign(es, esLocale), // 西班牙语
        fr: Object.assign(fr, frLocale), // 法语
        ko: Object.assign(ko, koLocale), // 韩语
        ru: Object.assign(ru, ruLocale), // 俄语
        pt: Object.assign(pt, ptLocale) // 葡萄牙语
    }
});

Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});

export default i18n;
